import { api } from "./api";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const deviceLabel = () => {
  const ua = navigator.userAgent;
  if (/iphone/i.test(ua)) return "iPhone";
  if (/ipad/i.test(ua)) return "iPad";
  if (/android/i.test(ua)) return "Android";
  if (/mac/i.test(ua)) return "Mac";
  if (/windows/i.test(ua)) return "Windows";
  return "Browser";
};

const getReg = async () => (await navigator.serviceWorker.getRegistration("/")) || navigator.serviceWorker.register("/service-worker.js", { scope: "/" });

export async function getPushState() {
  if (!pushSupported()) return { supported: false };
  const reg = await getReg();
  const sub = await reg.pushManager.getSubscription();
  const { data } = await api.get("/push/status", { params: sub ? { endpoint: sub.endpoint } : {} });
  return { supported: true, permission: Notification.permission, subscribed: !!sub && data.subscribed, configured: data.configured, devices: data.devices };
}

export async function enablePush() {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error(permission === "denied" ? "Permesso negato. Riattivalo dalle impostazioni del dispositivo." : "Permesso non concesso.");
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.configured || !data.public_key) throw new Error("Notifiche push non configurate sul server.");
  const reg = await getReg();
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.public_key) });
  const j = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys, device_label: deviceLabel() });
}

export async function disablePush() {
  const reg = await getReg();
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
}

export const sendTestPush = () => api.post("/push/test").then((r) => r.data);
